"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultProviderSort = exports.sortByPriority = exports.sortString = void 0;
var sortString = function (a, b) {
    var A = a.toUpperCase();
    var B = b.toUpperCase();
    if (A < B)
        return -1;
    if (A > B)
        return 1;
    return 0;
};
exports.sortString = sortString;
var sortByPriority = function (a, b) {
    var A = a.listPriority();
    var B = b.listPriority();
    if (A < B)
        return -1;
    if (A > B)
        return 1;
    return 0;
};
exports.sortByPriority = sortByPriority;
var defaultProviderSort = function (a, b) {
    return (0, exports.sortByPriority)(a, b) || (0, exports.sortString)(a.name, b.name);
};
exports.defaultProviderSort = defaultProviderSort;
//# sourceMappingURL=sort.js.map